import { EpicGroupDto } from '@/core';
import { EpicGroupTypesEnum } from './useTypeOptions';

export const useFilteredEpicGroupsByType = (epicGroups: EpicGroupDto[], filterValue: EpicGroupTypesEnum) => {
  const filteredEpicGroups =
    filterValue === EpicGroupTypesEnum.All
      ? epicGroups
      : epicGroups.filter((epicGroup) => epicGroup.type === filterValue);

  const getItemsQuantityByFilter = (filterValue: string) =>
    epicGroups.filter((epicGroup) => epicGroup.type === filterValue).length;

  return { filteredEpicGroups, getItemsQuantityByFilter };
};
